export default "__VITE_ASSET__BIIUbnkN__"